/**
 *
 * Asynchronously loads the component for RootContainer
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
